// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"9dddf229","195":"07ce807b","320":"3d0e6171"}[chunkId] + ".chunk.css";
};